// extracted by mini-css-extract-plugin
export default {"button":"styles-module__button--Yxk58","hasIcon":"styles-module__hasIcon--n0AO_","icon":"styles-module__icon--vxBlx"};